import { action } from 'satcheljs';
import InboxClassificationFilter from 'owa-mail-inbox-plus-store/lib/store/schema/InboxClassificationFilter';
import { addDatapointConfig } from 'owa-analytics-actions';
import getUserConfigurationTabFromInboxClassificationFilter from '../selectors/getUserConfigurationTabFromInboxClassificationFilter';

export const onInboxPivotSelected = action(
    'ON_INBOX_PIVOT_SELECTED',
    (
        currentPivot: InboxClassificationFilter,
        pivotToSelect: InboxClassificationFilter,
        tableViewId: string
    ) =>
        addDatapointConfig(
            {
                name: 'TnS_SelectInboxPivot',
                customData: {
                    currentPivot: getUserConfigurationTabFromInboxClassificationFilter(
                        currentPivot
                    ),
                    pivotToSelect: getUserConfigurationTabFromInboxClassificationFilter(
                        pivotToSelect
                    ),
                },
            },
            {
                currentPivot,
                pivotToSelect,
                tableViewId,
            }
        )
);
